import { useTranslation } from "react-i18next";
import { RTL_LANGUAGES, SelectLanguage } from "@app/constants";

type Props = {
  children?: JSX.Element;
  title: string;
  className?: string;
};

export function PageTitle({ children, title, className }: Props): JSX.Element {
  const { t, i18n } = useTranslation();
  const lang = i18n.language.split("-")[0] as SelectLanguage;
  const isRTL = RTL_LANGUAGES.includes(lang);

  return (
    <div className={`page-title d-flex align-items-center ${className}`}>
      <span
        style={{
          display: "flex",
          marginInlineEnd: isRTL ? "8px" : undefined,
        }}
      >
        {children}
      </span>
      <h2 className="title mb-0">{t(title)}</h2>
    </div>
  );
}
